import * as i0 from '@angular/core';
import { EventEmitter, Component, Output, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@fgb/core';
import { config } from '@fgb/core';
import * as i3 from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

class ClubSelectorComponent {
    constructor(memberQuery) {
        this.memberQuery = memberQuery;
        this.onClubSelected = new EventEmitter();
        this.clubIds = [];
        this.isSelectorOpen = false;
    }
    ngOnInit() {
        this.initClubs();
    }
    initClubs() {
        const context = this.memberQuery.getUserContext();
        this.clubIds = context?.clubs;
        this.selectedClubId = context.clubId;
    }
    getTeamLogoUrl(clubId) {
        return `${config.contentUrl}/image/clubs/${clubId}.png`;
    }
    toggleSelector() {
        this.isSelectorOpen = !this.isSelectorOpen;
    }
    onClubSelect(clubId) {
        this.selectedClubId = clubId;
        this.onClubSelected.emit(clubId);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClubSelectorComponent, deps: [{ token: i1.MemberQuery }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ClubSelectorComponent, selector: "fgbcl-club-selector", outputs: { onClubSelected: "onClubSelected" }, ngImport: i0, template: "<ng-container *ngIf=\"clubIds\">\r\n  <div class=\"club-selector\" (click)=\"toggleSelector()\">\r\n    <div class=\"club-selected\">\r\n      <div class=\"text\">\r\n        <span>{{ 'club.' + selectedClubId + '.name' | translate }}</span>\r\n      </div>\r\n      <div class=\"material-icons\">keyboard_arrow_down</div>\r\n    </div>\r\n    <div class=\"club-options\" *ngIf=\"isSelectorOpen\">\r\n      <div\r\n        class=\"club-option\"\r\n        *ngFor=\"let clubId of clubIds\"\r\n        (click)=\"onClubSelect(clubId)\"\r\n        [ngClass]=\"{ active: clubId == selectedClubId }\"\r\n      >\r\n        <span>{{ 'club.' + clubId + '.name' | translate }}</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClubSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fgbcl-club-selector', template: "<ng-container *ngIf=\"clubIds\">\r\n  <div class=\"club-selector\" (click)=\"toggleSelector()\">\r\n    <div class=\"club-selected\">\r\n      <div class=\"text\">\r\n        <span>{{ 'club.' + selectedClubId + '.name' | translate }}</span>\r\n      </div>\r\n      <div class=\"material-icons\">keyboard_arrow_down</div>\r\n    </div>\r\n    <div class=\"club-options\" *ngIf=\"isSelectorOpen\">\r\n      <div\r\n        class=\"club-option\"\r\n        *ngFor=\"let clubId of clubIds\"\r\n        (click)=\"onClubSelect(clubId)\"\r\n        [ngClass]=\"{ active: clubId == selectedClubId }\"\r\n      >\r\n        <span>{{ 'club.' + clubId + '.name' | translate }}</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n" }]
        }], ctorParameters: () => [{ type: i1.MemberQuery }], propDecorators: { onClubSelected: [{
                type: Output
            }] } });

class ClubSelectorModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClubSelectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ClubSelectorModule, declarations: [ClubSelectorComponent], imports: [CommonModule,
            FormsModule,
            FGBSharedModule], exports: [ClubSelectorComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClubSelectorModule, imports: [CommonModule,
            FormsModule,
            FGBSharedModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClubSelectorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ClubSelectorComponent
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        FGBSharedModule
                    ],
                    exports: [
                        ClubSelectorComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ClubSelectorComponent, ClubSelectorModule };
